// extracted by mini-css-extract-plugin
module.exports = {"root":"content_root__z1j0t","row":"content_row__2e3YH","body":"content_body__3CwcM","btnGroup":"content_btnGroup__1Q4q7","btn":"content_btn__3ukC-"};